export type Verdict = "confirmed" | "refuted" | "partial" | "unverified" | "developing";

export interface EvidenceItem {
  kind: string;
  title: string;
  note: string;
  status: "verified" | "pending" | "refuted";
}

export interface TimelineItem {
  time: string;
  text: string;
}

export interface Scoop {
  id: string;
  code: string;
  title: string;
  summary: string;
  category: string;
  tags: string[];
  verdict: Verdict;
  credibility: number;
  sources: number;
  heat: number;
  date: string;
  updated: string;
  readMinutes: number;
  author: string;
  cover: string;
  body: string[];
  evidence: EvidenceItem[];
  timeline: TimelineItem[];
  related: string[];
}

export const verdictMeta: Record<
  Verdict,
  { label: string; short: string; tone: string; desc: string }
> = {
  confirmed: {
    label: "已实锤",
    short: "实锤",
    tone: "bg-primary-500 text-background-50 dark:text-foreground-950",
    desc: "多项独立原始材料互相印证，关键细节可复核，结论明确。",
  },
  refuted: {
    label: "已辟谣",
    short: "辟谣",
    tone: "bg-secondary-500 text-background-50 dark:text-foreground-950",
    desc: "原始材料与官方记录均不支持流传说法，已确认信息失实。",
  },
  partial: {
    label: "部分属实",
    short: "部分",
    tone: "bg-accent-500 text-foreground-950",
    desc: "核心事实成立，但流传版本存在夸大、拼接或时间错位。",
  },
  unverified: {
    label: "待求证",
    short: "待证",
    tone: "bg-background-300 text-foreground-900",
    desc: "已有线索与材料，但尚缺关键来源，暂无法给出结论。",
  },
  developing: {
    label: "持续跟进",
    short: "跟进",
    tone: "bg-accent-200 text-accent-950",
    desc: "事件仍在变化，会随新证据更新档案内容与可信度评分。",
  },
};